import type { Data } from '@repo/strapi'
import { Paragraph } from '@/components/typography/Paragraph'
import { cn } from '@/lib/styles'

export const PricingCardHeader = ({
	pricingItem,
	className,
}: {
	pricingItem?: Data.Component<'shared.pricing-item'> | null
	className?: string
}) => {
	return (
		<div className={cn('flex flex-col gap-2 px-4', className)}>
			<Paragraph fontSize="bodyRegularMedium" className="text-neutral-500">
				{pricingItem?.abovePriceText}
			</Paragraph>
		</div>
	)
}

export default PricingCardHeader
